import { EQuestionsActionTypes } from '../../actions/questions';
import { TReduxActions, IQuestions } from '../../types/redux';
import { mapLikeAndDislikeReaction } from '../../mappers/LikeAndDislikeReaction';

export const defaultQuestionsState: IQuestions = {
  allIds: [],
  byId: {},
  hasMore: false,
  page: 0,
  loading: true,
};

export function questionsReducer(state: IQuestions = defaultQuestionsState, action: TReduxActions) {
  switch (action.type) {
    case EQuestionsActionTypes.SetQuestions: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case EQuestionsActionTypes.SetLoading: {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case EQuestionsActionTypes.SetAnswersVisibility: {
      const { questionId, state: areAnswersOpened } = action.payload;

      return {
        ...state,
        byId: {
          ...state.byId,
          [questionId]: {
            ...state.byId[questionId],
            areAnswersOpened,
          },
        },
      };
    }

    case EQuestionsActionTypes.AddAnswersToQuestion: {
      const { questionId, answerIds, hasMore, answersPage } = action.payload;

      const ids = new Set(state.byId[questionId].answers);
      answerIds.forEach(id => ids.add(id));

      return {
        ...state,
        byId: {
          ...state.byId,
          [questionId]: {
            ...state.byId[questionId],
            answers: [...ids],
            hasMoreAnswers: hasMore,
            answersPage,
          },
        },
      };
    }

    case EQuestionsActionTypes.SetAnswersPage: {
      const { questionId, page } = action.payload;

      return {
        ...state,
        byId: {
          ...state.byId,
          [questionId]: {
            ...state.byId[questionId],
            answersPage: page,
          },
        },
      };
    }

    case EQuestionsActionTypes.SetQuestionReaction: {
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.questionId]: {
            ...state.byId[action.payload.questionId],
            like: mapLikeAndDislikeReaction({
              currentState: state.byId[action.payload.questionId].like,
              nextState: action.payload.type,
            }),
          },
        },
      };
    }

    case EQuestionsActionTypes.SetQuestionsPage: {
      return {
        ...state,
        allIds: [...state.allIds, ...action.payload.allIds],
        byId: {
          ...state.byId,
          ...action.payload.byId,
        },
        hasMore: action.payload.hasMore,
        page: action.payload.page,
      };
    }

    default:
      return state;
  }
}
